import { Injectable } from '@angular/core';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: "root",
})
export class TimezoneswitchService {
  constructor(
    private modalService: NgbModal,
    private readonly userService: UserService,
    private readonly commonservice: CommonService
  ) {}

 
  SystemTimezone: any;SystemIANATimezone: any;
 
  compareCurrentTimeZoneWithSystemTimezone() {
    let ProfileTimeZone = this.userService.getLoggedUserTimeZone();
    this.SystemTimezone = new Date()
      .toLocaleDateString("en-US", { day: "2-digit", timeZoneName: "long" })
      .slice(4);
      this.SystemIANATimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
 
      /// make anonymous api call and get windows timezone id
    let windowsTimeZone: any;
    //GetWindowsTimeZoneFromIANA
    const TimeZone = { value: this.SystemIANATimezone, label:"" }
    this.userService.GetWindowsTimeZoneFromIANA(TimeZone).subscribe(result => {
      windowsTimeZone = result.Data;
 
      this.SystemTimezone = result.Data.Id;
 
      if (this.SystemTimezone.trim().toLowerCase() != ProfileTimeZone?.trim().toLowerCase()) {
        const TimeZonechanged = { value: this.SystemTimezone, label:"" }
        const modalRef1 = this.modalService.open(DeleteBoxComponent, {backdrop: false});
        modalRef1.componentInstance.Content = {
          heading: "Confirmation Message(s)",
          custommessage:
            "Your system time zone is currently " +
            this.SystemTimezone +
            ". Do you want to update your preferred time zone to this time zone?",
          ProceedButtonName: "Ok",
          TerminateButtonName: "Cancel",
        };
        modalRef1.result.then((result) => {
          {
            if (result == "okclick") {
              this.UserTimeZoneSave(TimeZonechanged);
            }
          }
        });
       // this.alertfyService.ConfirmationBanner("Your system time zone is currently " + this.SystemTimezone + ". Do you want to update your preferred time zone to this time zone?", () => this.UserTimeZoneSave(windowsTimeZone), "Ok", "Cancel");
      }
    })
 
 
  }
 
  UserTimeZoneSave = (windowsTimeZone) => {
    this.userService.timeZoneAutoSave(windowsTimeZone).subscribe((result) => {
      if (result != null) {
        if (result.Status === 0) {
          this.userService.setLoggedUserTimeZone(windowsTimeZone);
          this.commonservice.SuccessBanner(result.Message);
        }
      }
    });
  };
}
